import { keyframes } from "@emotion/core";
import { MenuPlacement } from "../types/MenuPlacement";

export const getMenuAnimationDirection = (placement: MenuPlacement) => {
    switch (placement) {
        case "top-start":
        case "top":
        case "top-end":
            return "bottom";
        case "right-start":
        case "right":
        case "right-end":
            return "left";
        case "left-end":
        case "left":
        case "left-start":
            return "right";
        case "bottom-end":
        case "bottom":
        case "bottom-start":
        default:
            return "top";
    }
};

// only to be used with Ursa
export const getMenuAnimation = (placement: MenuPlacement) => keyframes`
    from {
        margin-${getMenuAnimationDirection(placement)}: -8px;
    } to {
        margin-${getMenuAnimationDirection(placement)}: 0px;
    }
`;
